module.exports = __webpack_public_path__ + "img/design@2x.c690a8d.jpg";